<mat-card>
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Clientes com Inconsistências operacionais</mat-card-title>
        <button
            mat-mini-fab
            style=" margin-left: 10px"           
            matTooltip="Filtrar"
            (click)="filtra()">
            <mat-icon>search</mat-icon>
        </button>

    </mat-card-header>

    <mat-card-content>
        <ngx-datatable 
                #table
                [loadingIndicator]="loadingIndicator"
                class='material striped' 
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'
                [limit]="params.per_page"
                (sort)="onSort($event)"> 

                <ngx-datatable-column name="Nome" prop="nome" [sortable]="true" [width]="400">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{row.numero_xp}} - {{row.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="false" [width]="100">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                        {{row.sigla}}
                    </ng-template>
                </ngx-datatable-column>
               
                <ngx-datatable-column name="Operação" prop="operacao" [sortable]="true" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-operacao="value" ngx-datatable-cell-template>
                        {{operacao}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Qtd" prop="qtd" [sortable]="true" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                        {{qtd | number : '1.0-0'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Preço" prop="preco" [sortable]="true" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-preco="value" ngx-datatable-cell-template>
                        R$ {{preco | number : '1.2-2'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Inconsistência" prop="inconsistencia" [sortable]="true" [width]="400">
                    <ng-template let-rowIndex="rowIndex" let-inconsistencia="value" ngx-datatable-cell-template>  
                        {{inconsistencia}}                      
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>            
    </mat-card-content>
</mat-card>